import store from '@/store'
import { find, get } from 'lodash'
import { computed } from 'vue'
import { usePermissions } from '@/use/permissions'

export const useShopPoint = () => {
  const shopPointList = computed(() => get(store.state, 'shop.shopSetting.shopPoints'))
  const { checkAction } = usePermissions()

  const getShopPointData = (shopPointKey, dataKey) => {
    const shopPoint = find(shopPointList.value, { key: shopPointKey })
    return get(shopPoint, dataKey)
  }

  /**
   * 判斷是否為北捷捷運點
   * 當開啟北捷模組時,所有 external 類型的點數都視為捷運點
   * @param {Object} point - 點數物件
   * @returns {boolean}
   */
  const isTaipeiMetroPoint = (point) => {
    return point?.type === 'external' && checkAction('planModule.taipeiMetro.enable')
  }

  return {
    shopPointList,
    getShopPointData,
    isTaipeiMetroPoint,
  }
}
